import React from 'react'
import bannertt from "../assets/40.jpg"
import "./BirthdayDataStyles.css"
import banner6666 from "../assets/slide1.jpeg"

export const BirthdayData = () => {
    return (
        <div>
            <img src={bannertt} alt='no' className='wed' />
            <div class="wed-text">
                <h1>Birthday</h1>
                {/* <ul class="wed-text-1">
            <li className='homei'><a href="http://www.prachayikaevents.com/" >Home</a></li>
        </ul> */}
            </div>

            <div class="vilen">


                <div class="killer">
                    <h2>Birthday Party </h2>
                    <div class="textin"><img src={banner6666} className='imagic' alt="/" title="Pre Wedding Shoot in Delhi, Pre Wedding Photoshoot in Delhi - Showtime Event" /*align="right" style="padding-left:14px; padding-bottom:14px;"*/ />
                    <div className='key'>
                    If you are looking for Birthday Planner & Theme Planners, Decorators in Delhi, Jaipur then your search ends here. Prachayika Events is most reputed Birthday & Theme party planning company. Our experienced team will help to organize theme birthday party, birthday party decoration in your budget.<br></br><br></br>

                        {/* <strong>Our Highlights</strong><br></br> */}
                        Make birthday parties memorable for you & your kids. We will provide you all types of favors for birthday parties decorations or joint birthday theme parties for you<br></br><br></br>

                        <strong>Why Do You A Birthday Party Planner</strong><br></br>
                        Now you must be thinking why there is a need for a party planner for a birthday. In events like this, there is so much hustle. You have to manage so many things and also enjoy the event. So to ease your workload, we are there for you.Especially when it is a kid's birthday there are a lot of things that need to be dealt with, you require a birthday party planner. We assure you that we will take care of everything. We can organize a better event in a lesser budget, while you receive all the time to create those valuable memories.<br></br><br></br>

                        <strong>Birthday Party Themes</strong><br></br>
                        A lot of birthday parties these days are based on the theme culture. All the decorations and food are according to that specific theme. So if you hire a professional birthday party planner they can give you ideas about unique birthday party themes. The most common themes for kids’ birthdays these days are Barbie-themed, animal, Lego, princess, superheroes, harry potter, emoji themed or ocean themed birthday parties. We make the decorations and cake according to the theme. Getting dressed up according to the unique birthday party theme makes the kids more excited. To add to their excitement we make goody bags of that theme as well.<br></br><br></br>

                        </div>
                    </div>



                    <div class="sidebar-widget">
                        <div class="widget-content">
                            <div class="sidebar-title-two">
                                <h4>Services</h4>
                            </div>
                            <div className='tharki'>
                                <ul className='list'>
                                    <li><a href="/">Pre Wedding Events</a></li>
                                    <li><a href="/">Destination Wedding</a></li>
                                    <li><a href="/">Decoration</a></li>
                                    <li><a href="/">Photography & Vediography</a></li>
                                    <li><a href="/">Anniversary</a></li>
                                    <li><a href="/">Flower Decoration</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    )
}

